import React from "react";
import Field from "../../Common/Field/Field";
import App from "../../../pages/report/multiSelect";

const FabricLibrary = props => {
    return (
        <div class="col-md-12 text-center d-flex justify-content-center">
            <div className="col-md-2" style={{ zIndex: "1000" }}>
                <label>Fabric No.</label>
                <Field
                    inputType="text"
                    inputName="fabNumber"
                    value={props.fabNumber}
                    onChange={props.updateState}
                    disabled={false}
                    className="w-100"
                />
            </div>
            <div className="col-md-2" style={{ zIndex: "1000" }}>
                <label>Count &amp; Construction</label>
                <Field
                    inputType="text"
                    inputName="countCons"
                    value={props.countCons}
                    onChange={props.updateState}
                    disabled={false}
                    className="w-100"
                />
            </div>
            <div className="col-md-2" style={{ zIndex: "1000" }}>
                <label>Quality</label>
                <Field
                    inputType="select"
                    inputName="quality"
                    value={props.quality}
                    options={props.fabQualityList}
                    onChange={props.updateState}
                    disabled={false}
                    className="Select-control"
                />
            </div>
            <div className="col-md-2" style={{ zIndex: "1000" }}>

                <label>From</label>
                <Field
                    inputType="date"
                    inputName="fromDate"
                    label="from Date"
                    value={props.fromDate}
                    onChange={props.updateState}
                    disabled={false}
                    className="Select-control"
                />
            </div>
            <div className="col-md-2" style={{ zIndex: "1000" }}>
                <label>To</label>
                <Field
                    inputType="date"
                    inputName="toDate"
                    label="to Date"
                    value={props.toDate}
                    onChange={props.updateState}
                    disabled={false}
                    className="Select-control"
                />
            </div>

        </div>

    );
};

export default FabricLibrary;


// WEBPACK FOOTER //
// ./src/components/Report/forms/FabricLibrary.js